/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Ops_Title3Inputs */

const en_svc_ai_integration_ops_title3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LLM Ops`)
};

const ar_svc_ai_integration_ops_title3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عمليات نماذج اللغة الكبيرة`)
};

const bn_svc_ai_integration_ops_title3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LLM অপস`)
};

const de_svc_ai_integration_ops_title3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LLM Ops`)
};

const es_svc_ai_integration_ops_title3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operaciones LLM`)
};

const fr_svc_ai_integration_ops_title3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opérations LLM`)
};

const pt_svc_ai_integration_ops_title3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operações LLM`)
};

const zh_svc_ai_integration_ops_title3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法学硕士运营`)
};

const tr_svc_ai_integration_ops_title3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yüksek Lisans Operasyonları`)
};

const ru_svc_ai_integration_ops_title3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LLM Операции`)
};

const pl_svc_ai_integration_ops_title3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LLM Op`)
};

/**
* | output |
* | --- |
* | "LLM Ops" |
*
* @param {Svc_Ai_Integration_Ops_Title3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_ops_title3 = /** @type {((inputs?: Svc_Ai_Integration_Ops_Title3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Ops_Title3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_ops_title3(inputs)
	if (locale === "bn") return bn_svc_ai_integration_ops_title3(inputs)
	if (locale === "de") return de_svc_ai_integration_ops_title3(inputs)
	if (locale === "es") return es_svc_ai_integration_ops_title3(inputs)
	if (locale === "fr") return fr_svc_ai_integration_ops_title3(inputs)
	if (locale === "pt") return pt_svc_ai_integration_ops_title3(inputs)
	if (locale === "zh") return zh_svc_ai_integration_ops_title3(inputs)
	if (locale === "tr") return tr_svc_ai_integration_ops_title3(inputs)
	if (locale === "ru") return ru_svc_ai_integration_ops_title3(inputs)
	if (locale === "pl") return pl_svc_ai_integration_ops_title3(inputs)
	return en_svc_ai_integration_ops_title3(inputs)
});
export { svc_ai_integration_ops_title3 as "svc_ai-integration_OPS_title" }